import { render, staticRenderFns } from "./Form13Table.vue?vue&type=template&id=dd02d576"
import script from "./Form13Table.vue?vue&type=script&lang=ts"
export * from "./Form13Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports